"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiJobsClient = void 0;
const types_1 = require("../../../types");
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const PageableConverter_1 = require("../../common/model/PageableConverter");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
class ApiJobsClient extends ApiSubClient_1.ApiSubClient {
    async getAll(pageRequest, filter) {
        const jobsLink = await this.getLinkOrThrow('jobs');
        if (!jobsLink) {
            throw Error('Not authorized to view jobs');
        }
        const manuallyCreated = filter && filter.manuallyCreated !== undefined
            ? filter.manuallyCreated.toString()
            : undefined;
        return this.axios
            .get((0, expandUrlTemplate_1.default)(jobsLink.href, {
            page: pageRequest.page,
            size: pageRequest.size,
            manuallyCreated: manuallyCreated,
        }))
            .then((response) => {
            return PageableConverter_1.PageableConverter.convert(response.data, 'jobs', this.convertJobResponse);
        });
    }
    async get(id) {
        const jobDetailsLink = this.getLinkOrThrow('jobDetails');
        const expandedLink = (0, expandUrlTemplate_1.default)(jobDetailsLink.href, { id });
        try {
            const response = await this.axios.get(expandedLink);
            return this.convertJobResponse(response.data);
        }
        catch (e) {
            if ((0, types_1.isBoclipsApiError)(e)) {
                throw {
                    error: e.error,
                    message: e.message,
                    path: expandedLink,
                    status: e.status,
                    timestamp: new Date(),
                };
            }
            else {
                throw e;
            }
        }
    }
    convertJobResponse(response) {
        const { id, createdAt, provider, status, videoSummary, errors, _links, videos, } = response;
        return {
            id,
            createdAt: new Date(createdAt),
            provider,
            status,
            videoSummary,
            videos,
            errors,
            links: {
                self: new types_1.Link(_links.self),
                errorsMetadata: _links.errorsMetadata && new types_1.Link(_links.errorsMetadata),
            },
        };
    }
}
exports.ApiJobsClient = ApiJobsClient;
//# sourceMappingURL=ApiJobsClient.js.map